var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container_header"},[_c('header',{attrs:{"role":"banner"}},[_c('div',{staticClass:"logo logo-header-new"})])])}]

export { render, staticRenderFns }